import type { FC } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Home, Phone, Mail } from 'lucide-react';

const FooterBefore: FC = () => {
  // Get the current year dynamically
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white text-slate-700">
      <div className="container mx-auto px-4 pt-12 pb-6">

        {/* Logos Section */}
        <div className="flex flex-col items-center gap-4">
          <div className="flex flex-col md:flex-row items-start gap-8 md:gap-20">

            {/* "Powered By" Section */}
            <div className="flex flex-col items-center">
              <p className="text-lg font-semibold text-slate-600 mb-2">Powered By</p>
              <Image
                src="/sdecLogo.png"
                alt="Sarawak Digital Economy Corporation (SDEC) Logo"
                width={180}
                height={80}
                className="h-auto"
              />
            </div>

            {/* "Operated By" Section */}
            <div className="flex flex-col items-center transform -translate-x-3 md:translate-x-0">
              <p className="text-lg font-semibold text-slate-600 mb-2">Operated By</p>
              <Image
                src="/fitLogo.png"
                alt="FIT Pioneer Logo"
                width={200}
                height={80}
                className="h-auto transform translate-y-1 translate-x-2"
              />
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200 my-10"></div>

        {/* Company, Legal, Contact Us Sections */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 my-10 px-4 md:px-35">

          {/* Company Section */}
          <div>
            <h3 className="text-md font-bold text-slate-800 mb-2">Company</h3>
            <ul className="space-y-1">
              <li>
                <Link href="/aboutus" className="hover:text-indigo-700 hover:underline text-sm">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Section */}
          <div>
            <h3 className="text-md font-bold text-slate-800 mb-2">Legal</h3>
            <ul className="space-y-1">
              <li>
                <Link href="/terms-and-conditions" className="hover:text-indigo-700 hover:underline text-sm">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link href="/privacy-policy" className="hover:text-indigo-700 hover:underline text-sm">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Us Section */}
          <div>
            <h3 className="text-md font-bold text-slate-800 mb-2">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Home size={18} className="flex-shrink-0 text-slate-500" />
                <div className="flex flex-col">
                  <span>Sarawak Digital Economy Corporation Berhad, Level 6, Wisma Satok, Jalan Satok, 93400 Kuching, Sarawak.</span>
                  <span className="mt-2">Suite 7-02, 7th Floor, Menara Keck Seng, 203, Jln Bukit Bintang, Bukit Bintang, 55100 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur.</span>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-slate-500" />
                <span>082-549 005 / 03-2116 5978</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-slate-500" />
                <span>hello@sdemarketplace.my</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="text-center mt-12">
          <p className="text-sm text-gray-400">
            &copy; {currentYear} SDeMARKETPLACE - All rights reserved.
          </p>
        </div>

      </div>
    </footer>
  );
};

export default FooterBefore;